import type {
  AddressBookEntryDto,
  AddressBookCreateDto,
  AddressBookUpdateDto,
} from '@camper-diary/shared';
import { api } from './client';

export type AddressBookEntry = AddressBookEntryDto;

export function listAddressBook() {
  return api<AddressBookEntry[]>('/address-book');
}

export function createAddressBookEntry(input: AddressBookCreateDto) {
  return api<AddressBookEntry>('/address-book', { method: 'POST', body: input });
}

export function updateAddressBookEntry(id: string, input: AddressBookUpdateDto) {
  return api<AddressBookEntry>(`/address-book/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: input,
  });
}

export function deleteAddressBookEntry(id: string) {
  return api<null>(`/address-book/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
